// extracted by mini-css-extract-plugin
export default {"root":"DialogPageContent_root__MxprR"};